import React, { useState, useEffect } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

const PressPopup = ({ 
  imageSrc = '/אראלחןחדלותמשותפת.jpg',
  title = 'נכתב עלינו ב-TheMarker!',
  description = 'משרדנו סוקר לאחרונה בכתבה מקיפה על השפעת עורכי הדין בתחום ההוצאה לפועל, המתארת את ההצלחות הבולטות של המשרד בשנים האחרונות.',
  buttonText = 'קראו את הכתבה המלאה',
  articleUrl = 'https://www.themarker.com/labels/lawyers-team/2025-06-24/ty-article-labels/00000197-a075-d02a-a1df-a3ff6bfa0001',
  showAfterSeconds = 3,
  showOnPages = ['/']
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // בדוק אם כבר הוצג הפופאפ בביקור הנוכחי (לכל האתר)
    const hasShownInSession = sessionStorage.getItem('pressPopupShownThisVisit');
    
    if (!hasShownInSession) {
      const timer = setTimeout(() => {
        setIsVisible(true);
        setIsAnimating(true);
      }, showAfterSeconds * 1000);

      return () => clearTimeout(timer);
    }
  }, [showAfterSeconds]);

  const closePopup = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
      // שמור בסשן שכבר הוצג לכל הביקור באתר
      sessionStorage.setItem('pressPopupShownThisVisit', 'true');
    }, 300);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      closePopup();
    }
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div 
        className={`bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto transform transition-all duration-300 ${
          isAnimating ? 'scale-100 opacity-100' : 'scale-95 opacity-0'
        }`}
      >
        {/* כותרת עם כפתור סגירה */}
        <div className="relative p-6 border-b border-gray-200">
          <button
            onClick={closePopup}
            className="absolute top-4 left-4 p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <XMarkIcon className="w-5 h-5 text-gray-500" />
          </button>
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full mb-3">
              <span className="text-2xl">📰</span>
            </div>
            <h2 className="text-2xl font-bold text-gray-900">{title}</h2>
          </div>
        </div>

        {/* תוכן */}
        <div className="p-6">
          <div className="flex flex-col md:flex-row gap-6">
            <div className="flex-shrink-0 w-full md:w-2/5">
              <img
                src={imageSrc}
                alt="כתבה על משרד עורכי הדין"
                className="rounded-lg shadow-lg w-full object-cover h-48 md:h-full"
              />
            </div>
            <div className="flex-grow text-right">
              <p className="text-gray-600 mb-6 leading-relaxed text-lg">
                {description}
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href={articleUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 text-center px-6 py-3 text-white bg-blue-600 hover:bg-blue-700 rounded-lg font-medium transition-colors duration-200 shadow-md"
                  onClick={() => {
                    // סגור את הפופאפ אחרי קליק על הקישור
                    setTimeout(closePopup, 100);
                  }}
                >
                  {buttonText}
                </a>
                <button
                  onClick={closePopup}
                  className="flex-1 px-6 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors duration-200"
                >
                  סגור
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* פוטר */}
    
      </div>
    </div>
  );
};

export default PressPopup;